import { Navigate } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { usePortalUserStore } from "@/app/stores";
import { ScheduleContextProvider } from "@/features/consultations/contexts";
import { APPOINTMENT_TYPE } from "@/features/consultations/models";
import {
  ScheduleAvailableDaysCard,
  ScheduleAvailableTimeSlotCard,
} from "@/features/consultations/sections";
import { Header, ScrollArea } from "@/shared/ui";
import { useEmbeddablesForms } from "../context";
import { ScheduleAppointmentSubmit } from "../sections";

export const ScheduleAppointment = () => {
  const needsInitialSync = usePortalUserStore(
    (state) => state.needsEmbeddablesInitialSync,
  );

  // Currently, Embeddables only allows you to subscribe to one product.
  const firstSubscriptionId = usePortalUserStore(
    (state) => state.portalUser?.subscriptions[0]?.id,
  );

  const {
    patient: { location },
  } = useEmbeddablesForms();

  if (!needsInitialSync) {
    return <Navigate to={ROUTES.HOME} />;
  }

  return (
    <ScrollArea className="h-dvh">
      <div className="flex h-full flex-col gap-8 p-6 md:py-12 lg:px-16 xl:px-44 2xl:px-80">
        <Header.Root variant="secondary">
          <Header.Content className="text-center">
            <Header.Title>{t`Let's meet`}</Header.Title>

            <Header.Description className="text-lg text-neutral-800">
              {t`Choose the perfect time and date`}
            </Header.Description>
          </Header.Content>
        </Header.Root>

        <ScheduleContextProvider
          appointmentType={APPOINTMENT_TYPE.MEDICATION_REQUEST_INITIAL}
          defaultLanguage="en"
          state={location?.state}
          subscriptionId={firstSubscriptionId}
        >
          <main className="flex flex-col gap-8 md:flex-row md:gap-16">
            <ScheduleAvailableDaysCard
              title={t`1. Choose an available day:`}
              className="md:w-3/5"
              ghost
            />
            <ScheduleAvailableTimeSlotCard
              titleStep={2}
              variant="section"
              className="md:w-2/5"
            />
          </main>

          <ScheduleAppointmentSubmit />
        </ScheduleContextProvider>
      </div>
    </ScrollArea>
  );
};
